module.exports = __webpack_public_path__ + "img/Vermutete_Gefahr_durch_Gas.7373434a.svg";